import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    title: {
      margin: "40px 0 30px",
      color: theme.palette.primary.main,
      fontSize: theme.typography.pxToRem(28),
      lineHeight: theme.typography.pxToRem(34),
      letterSpacing: 1.4,
    },
    button: {
      color: theme.palette.common.white,
      fontSize: theme.typography.pxToRem(24),
    },
  }),
  { name: "Webcam" },
);
